import { Alignment } from '../../interfaces/Alignment';
import { SlotDefinition, SlotType } from '../../interfaces/SlotDefinition';

export enum SlotNodeVariant {
  FIRST = 'first',
  SECOND = 'second',
  START = 'start',
  END = 'end',
}

export enum SlotNodeType {
  SINGLE = 'slot',
  PAIR = 'slotPair',
  LINE = 'slotLine',
}

const slotTypeToNodeType = (slotType: SlotType): SlotNodeType => {
  switch (slotType) {
    case SlotType.SINGLE:
      return SlotNodeType.SINGLE;
    case SlotType.PAIR:
      return SlotNodeType.PAIR;
    case SlotType.LINE:
      return SlotNodeType.LINE;
  }
};

// Explicit null/undefined check because "0" evaluates like null and undefined to false.
const checkNotNullOrUndefined = (variable: any): boolean => {
  if (variable === null || variable === undefined) {
    return false;
  }
  return true;
};

export const createSlotNodeName = (slot: SlotDefinition, variant?: SlotNodeVariant): string => {
  const slotNodeType = slotTypeToNodeType(slot.type);
  const alignment =
    slot.type === SlotType.SINGLE && slot.alignment !== Alignment.NONE ? `_${slot.alignment}` : '';
  const xIndex =
    slot.type === SlotType.SINGLE && checkNotNullOrUndefined(slot.xIndex)
      ? `_${slot.xIndex.toString().padStart(3, '0')}`
      : '';
  const yIndex =
    slot.type === SlotType.SINGLE && checkNotNullOrUndefined(slot.yIndex)
      ? `_${slot.yIndex.toString().padStart(3, '0')}`
      : '';
  const slotVariant = variant ? '_' + variant : '';

  return `${slotNodeType}_${slot.name}${alignment}${xIndex}${yIndex}${slotVariant}`;
};

// Function to avoid javascript problem with operations on very small numbers
export const normalizeDecimals = (value: number): number => {
  // Rounding up on 3rd decimal because we are working with centimeters in scene
  // That's anything smaller than 0.01 millimeter which becomes irrelevant at that point
  return parseFloat(value.toFixed(3));
};

export const convertToWholeMillimeters = (valueInCm: number): number => {
  return Math.floor(Math.abs(valueInCm) * 10);
};
